

























import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import CommentAdd from '@/views/organisms/CommentAdd.vue'
import CommentHistory from '@/views/organisms/CommentHistory.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import RightBox from '@/views/molecules/RightBox.vue'
import SearchButton from '@/views/atoms/SearchButton.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import StatusBox from '@/views/molecules/StatusBox.vue'
import Global from '@/common/global.js'

export default
  components: {
    Popup
    BlueButton
    TextBox
    CommentAdd
    CommentHistory
    RightBox
    SearchButton
    CheckBox
    StatusBox
  }

  props:
    export_id:
      type: String
      default: ''
    booking:
      type: String
      default: ''
    shipper_name:
      type: String
      default: ''

  watch: {
    list: (e) ->
      @list = e
  }

  data: () ->
    list: []
    mailList: store.getters.mailList,
    mailaddressList: [],
    address: '',
    postaddress: [],
    postaddressName: [],

  created: () ->
    store.dispatch('initPostParam')
    api = new ApiClient()
    data = await api.get('/fc/comment/detail/' + @export_id)
    @list = data.list.agent
    store.dispatch('setDetailParam', data)
    for rows, index in await @mailList
      @mailaddressList.push(rows)

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save_comment: () ->
      getParam = store.getters.getPostParam
      comment = getParam.agent_fc_comment
      if !comment
        return alert('Enter your comments')
      else
        if @list
          if @list[0].comment == comment
            return alert('Your comment has been saved and sent.')
        param = 
          id: getParam.id
          export_id: @export_id
          comment: getParam.agent_fc_comment
          agent_flg: 1
        api = new ApiClient()
        data = await api.post('/fc/comment/save', param)
        if data.errors.length == 0
          @$emit('click')
    send_mail: () ->
      getParam = store.getters.getPostParam
      comment = getParam.agent_fc_comment
      if @postaddress.length == 0 || !comment
        if !comment
          return alert('Enter your comments')
        return alert('Please select an email address')
      else
        if @list
          if @list[0].comment == comment
            return alert('Your comment has been saved and sent.')
      if @postaddress.length
        getParam = store.getters.getPostParam
        param =
          export_id: @export_id
          mail_list: @postaddress
          mail_name_list: @postaddressName
          comment: getParam.agent_fc_comment
          agent_flg: 1
        if getParam.id
          param.id = getParam.id
        api = new ApiClient()
        data = await api.post('/fc/comment/send_mail', param)
        if data.errors.length == 0
          @$emit('click')
      else
        alert('Please select an email address')
    addressChange: (e) ->
      @address = e
    addressCheck: (e) ->
      if e
        mailaddress = @postaddress.map (el) -> el.mailaddress
        index = mailaddress.indexOf(@address)
        if index < 0
          @postaddress.push('mailaddress': @address)
          for lists in @mailaddressList
            for item in lists
              if item.mailaddress == @address
                @postaddressName.push(item.name)
      else
        mailaddress = @postaddress.map (el) -> el.mailaddress
        index = mailaddress.indexOf(@address)
        @postaddress.splice(index, 1)
        @postaddressName.splice(index, 1)
  }
